import { DomService } from '../dom';
import { FundApiService } from '../fund-api';

export async function getDisclaimers(disclaimers = []): Promise<any[]> {
  const disclaimerOrder = DomService.getGlobalContent().disclaimerReihenfolge?.split(',');

  const articleDisclaimers = [...disclaimers];

  articleDisclaimers.sort((a, b) => disclaimerOrder.indexOf(a) - disclaimerOrder.indexOf(b));

  const result = [];
  const legalDisclaimers = await FundApiService.getRechtlicheTexte();
  const requiredLegalDisclaimers = legalDisclaimers.filter((d) => disclaimers.includes(d.name));
  const legalDisclaimersNames = requiredLegalDisclaimers.reduce((acc, val) => {
    if (disclaimers.includes(val.name)) {
      acc.push(val.name);
    }
    return acc;
  }, []);
  /* eslint-disable no-restricted-syntax */
  for (const d of articleDisclaimers) {
    /* eslint-disable no-await-in-loop */
    if (!legalDisclaimersNames.includes(d)) {
      try {
        const res = await FundApiService.getFixtexte(d);
        if (res.length > 0) {
          result.push({
            id: res[0].name,
            text: res[0].text,
            bold: d === 'Hinweis auf Kapitalverluste',
          });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const disclaimer = requiredLegalDisclaimers.filter((r) => r.name === d)[0] as any;
      if (disclaimer) {
        result.push({
          id: disclaimer.name,
          text: disclaimer.text,
          bold: false,
        });
      }
    }
  }

  return result;
}
